// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"af0ba27edcd14005180f","404":"d673470ec1ea156859e2","406":"6274717cfb56877844e8"}[chunkId] + ".css";
};